import { Injectable } from '@angular/core';
import { Repository } from '@clavisco/core';

@Injectable({
  providedIn: 'root'
})
export class DataStorageService {

  private data: any;

  constructor() { }

  /**
 * Retrieves an item from the storage and returns it as a specific type.
 * 
 * @param itemName The name of the item to retrieve.
 * @returns The retrieved item of type T.
 */
  GetItem<T>(itemName: string): T {
    const item = Repository.Behavior.GetStorageObject(itemName);
    return item! as T;
  }

  /**
 * Removes an item from the storage by its name.
 * 
 * @param itemName The name of the item to remove.
 */
  RemoveItem<T>(itemName: string): void {
    const item = Repository.Behavior.GetStorageObject(itemName) as T;
    if (item) {
      Repository.Behavior.DeleteStorageObject(itemName);
    }
  }

  /**
 * Sets an item in the storage with a specific name and value.
 * 
 * @param itemName The name of the item to store.
 * @param item The value to store.
 */
  SetItem<T>(itemName: string, item: T): void {
    Repository.Behavior.SetStorage(item, itemName);
  }

  /**
   * Sets internal data storage for temporary use.
   * 
   * @param value The value to store temporarily.
   */
  setData(value: any) : void {
    this.data = value
  }

  /**
 * Gets the internally stored data.
 * 
 * @returns The temporarily stored data.
 */
  getData() :any {
    return this.data;
  }

  /**
 * Removes the internal data.
 */
  removeData() : void {
    this.data = null;
  }

}
